export default {"src":"/_next/static/media/ssosBannerIcon.397cb6f2.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};